<ng-container *ifScreenSize="screenType.Desktop">
  <ng-container *notInPopulation="[population.Kids]">
    <div class="bg-primary">
      <img class="w-100" src="assets/images/rewards-banner-desktop.png" />
    </div>
  </ng-container>
</ng-container>

<div class="container d-none d-lg-block wallet-background">
  <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>
</div>

<div class="d-lg-none d-block">
  <fgb-page-header
    [pageTitle]="'nav.wallet'"
    [showBalance]="false"
    [showFooter]="false"
    [showBanner]="false"
    [backButtonLink]="'/'"
  />
  <div class="barcode-div">
    <fgb-barcode></fgb-barcode>
  </div>
</div>

<!-- Wallet -->
<div #walletContainer class="wallet-container">
  <ng-container *ifScreenSize="screenType.Mobile">
    <div class="grab-point"><span class="minimize-icon"> </span></div>
  </ng-container>

  <ng-container *ngIf="walletItems$ | async as walletItems">
    <ng-container *ngIf="walletItems?.length > 0; else noWalletItems">
      <div class="wallet-redeem-carousel pt-4">
        <div class="container wallet-mobile-padding">
          <fgbcl-rewards-wallet-redeem-list [unRedeemedItems]="walletItems"></fgbcl-rewards-wallet-redeem-list>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #noWalletItems>
    <div class="container">
      <h5 class="no-wallet-items mt-4 mb-3 fw-bold text-white">{{ 'rewards.wallet.no.items' | translate }}</h5>
      <div class="border rounded bg-secondary">
        <div class="no-wallet-items-description fw-bold font-size-12 text-center text-white py-3">
          {{ 'rewards.wallet.no.items.description' | translate }}
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Offers -->
  <ng-container *notInPopulation="[population.Kids]">
    <fgbcl-campaigns-offers-list [showAllOffers]="false"></fgbcl-campaigns-offers-list>
  </ng-container>

  <div class="container text-center mb-lg-5 claimed-button-div">
    <div class="claimed-button">
      <div class="claimed-button-text">
        <h5 class="claimed-heading mb-1">{{ 'wallet.claimed.heading' | translate }}</h5>
        <div class="font-size-14">{{ 'wallet.claimed.description' | translate }}</div>
      </div>
      <a
        class="font-size-14 claimed-text fw-bold btn btn-quaternary text-black rounded border-0"
        [routerLink]="['/rewards/claimed']"
      >
        {{ 'rewards.wallet.view.claimed' | translate }}
      </a>
    </div>
  </div>
</div>
